module.exports = "/images/powered_by_google.svg";